/**
 * Slack message types shared between the server integration and the
 * client-side fetch wrapper.
 */

export enum SlackChannel {
  NEW_MISSING_DATA_REQUESTS = 'new-missing-data-requests',
  NEW_CONCIERGE_REQUEST = 'new-concierge-request',
  NEW_VRM_EVENT_INQUIRIES = 'new-vrm-event-inquiries',
  NEW_VRM_INBOUND_PROPOSAL_EMAIL = 'new-vrm-inbound-proposal-email',
  NEW_GHOST_VENUE = 'new-ghost-venue',
  NEW_REVEL_REC_REQUEST = 'new-revel-rec-request',
  NEW_PRODUCT_LEAD_GROWTH = 'new-product-lead-growth',
  NEW_EVENT_CREATED = 'new-event-created',
  NEW_ENTITY_SPECIFIC_TAG = 'new-entity-specific-tag',
  ALERTS_CRM_INQUIRIES = 'alerts-crm-inquiries',
}

export enum SlackColor {
  GREEN = 'good',
  RED = 'danger',
  YELLOW = 'warning',
  BLUE = '#0080ff',
}

export interface SlackMessageRequest {
  message: string
  channel: SlackChannel
  fields?: Record<string, string>
  level?: SlackColor | string
}
